import React from 'react';
import {
  FacebookOutlined,
  LaptopOutlined,
  MailOutlined,
  MessageOutlined,
  WhatsAppOutlined,
} from '@ant-design/icons';
import { Channel, CHANNEL_CONFIG } from '../../utils/channels';

// ADR-025 channel colours
const CHANNEL_COLOR: Record<Channel, string> = {
  sms: '#4cb04f',
  whatsapp: '#25D366',
  messenger: '#0084FF',
  webchat: '#722ed1',
  email: '#1677ff',
};

const CHANNEL_ICON: Record<Channel, React.ComponentType<any>> = {
  sms: MessageOutlined,
  whatsapp: WhatsAppOutlined,
  messenger: FacebookOutlined,
  webchat: LaptopOutlined,
  email: MailOutlined,
};

export function channelColor(channel?: Channel | string | null): string | undefined {
  return channel ? CHANNEL_COLOR[channel as Channel] : undefined;
}

export interface ChannelIconProps {
  channel?: Channel | string | null;
  size?: number;
  withLabel?: boolean;
  style?: React.CSSProperties;
  className?: string;
}

/**
 * Channel glyph in its brand colour. Renders nothing for unknown channels so
 * callers can pass whatever the thread carries without guarding.
 */
const ChannelIcon: React.FC<ChannelIconProps> = ({
  channel,
  size = 14,
  withLabel = false,
  style,
  className,
}) => {
  const Icon = channel ? CHANNEL_ICON[channel as Channel] : undefined;
  if (!Icon) return null;
  const color = CHANNEL_COLOR[channel as Channel];
  const label = CHANNEL_CONFIG[channel as Channel].label;

  if (!withLabel) {
    return (
      <Icon
        className={className}
        style={{ color, fontSize: size, ...style }}
        aria-label={label}
        data-channel={channel}
      />
    );
  }

  return (
    <span
      className={className}
      data-channel={channel}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 4, ...style }}
    >
      <Icon style={{ color, fontSize: size }} aria-hidden />
      <span style={{ fontSize: size }}>{label}</span>
    </span>
  );
};

export default ChannelIcon;
